var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded && _vm.isHaveCategory)?_c('div',[_c('CategorySlider',{attrs:{"categorie":_vm.categories},on:{"changeCategory":function($event){return _vm.changeCategory($event)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }